import { createAction } from '@reduxjs/toolkit';
import type { UpdateFundraisingRequest } from '@shared/schemas';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions
 * (the saga owns the resulting `load*` / `save*` transitions).
 */

/** Load the fundraising by id (dispatched on mount). */
export const loadRequested = createAction<string>('editFundraising/loadRequested');

/** Persist the current draft (dispatched on Save). */
export const submitRequested = createAction('editFundraising/submitRequested');

/** Delete a round for good (the ⋮ menu, or "Delete round" in the Edit dialog). */
export const deleteRequested = createAction<string>('editFundraising/deleteRequested');

/**
 * Put a round back the way it was: the "Undo" of an update. Carries its own
 * body: the draft has moved on by the time the toast is clicked.
 */
export const revertRequested = createAction<{ id: string; request: UpdateFundraisingRequest }>(
  'editFundraising/revertRequested',
);
